var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-xs-center"},[_vm._v("404")]),_c('h1',{staticClass:"text-xs-center"},[_vm._v("Такой страницы не существует")])])}]

export { render, staticRenderFns }